import { render, staticRenderFns } from "./cGauge.vue?vue&type=template&id=40203520&scoped=true&"
import script from "./cGauge.vue?vue&type=script&lang=js&"
export * from "./cGauge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40203520",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40203520')) {
      api.createRecord('40203520', component.options)
    } else {
      api.reload('40203520', component.options)
    }
    module.hot.accept("./cGauge.vue?vue&type=template&id=40203520&scoped=true&", function () {
      api.rerender('40203520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/cGauge.vue"
export default component.exports